import React from 'react';
import ProfileDetails from '../components/ProfileDetails.js';
import AppBar from '../components/AppBar.js';

function Profile(props) {
    return (
        <div>
            <AppBar backTo='' displayText='Home' />
            <ProfileDetails identification={props.identification} />
        </div>
    )
}

export default Profile;
